import React from 'react';
export function StickyAlertBar() {
  const text = '🔥 SOLO POR HOY +7 BONOS GRATIS 🔥';
  return <div className="fixed top-0 left-0 w-full bg-gold text-navy-900 font-bold py-2 z-50 overflow-hidden" data-id="element-304">
      <div className="marquee-container animate-marquee whitespace-nowrap" data-id="element-305">
        {/* We duplicate the content multiple times to ensure a smooth infinite scroll */}
        <div className="flex-1 flex justify-around" data-id="element-306">
          <span data-id="element-307">{text}</span>
          <span data-id="element-308">{text}</span>
          <span data-id="element-309">{text}</span>
          <span data-id="element-310">{text}</span>
        </div>
        <div className="flex-1 flex justify-around" data-id="element-311">
          <span data-id="element-312">{text}</span>
          <span data-id="element-313">{text}</span>
          <span data-id="element-314">{text}</span>
          <span data-id="element-315">{text}</span>
        </div>
      </div>
    </div>;
}